import { GridTableRow } from "../general/Tables/GridTable/GridTable";
import styles from "./ImporterPage.module.scss";

interface Props {
    rowNumber: number;
}

export const ImporterEmptyRow: React.FC<Props> = ({ rowNumber }) => {
    const stickyLeftNumber = 3;
    const otherNumber = 7;
    return (
        <GridTableRow columnBorders className={styles.row}>
            <GridTableRow columnBorders className={styles.stickyLeft}>
                <div className={styles.rowNumber}>{rowNumber}</div>
                {Array.from({ length: stickyLeftNumber - 1 }).map(() => (
                    <div />
                ))}
            </GridTableRow>
            {Array.from({ length: otherNumber }).map(() => (
                <div />
            ))}
        </GridTableRow>
    );
};
